import { useLayoutEffect, useState } from 'react'

function useWindowSize() {
  const [size, setSize] = useState([0, 0])
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return size
}

export const IsMobile = () => {
  const [width] = useWindowSize()
  return width < 768
}

export const IsMonitor = () => {
  const [width] = useWindowSize()
  return width > 1220
}
